import config from '@efdigital/ll-xceed-v2/config/environment';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import { IfCoach } from '../user/rights/if-coach.gts';
import { IfCoachee } from '../user/rights/if-coachee.gts';
import ThemeToggle from './theme-toggle.gts';

interface HeaderSignature {
  Element: HTMLElement;
}

const XCEED_HOME_URL = config['ll-apps'].xceed;

const Header: TemplateOnlyComponent<HeaderSignature> = <template>
  <div
    class="navbar navbar-expand ll-bg-chrome shadow-sm border-bottom py-2"
    ...attributes
  >
    <div class="container-fluid">
      <a href={{XCEED_HOME_URL}} class="navbar-brand fw-bold ms-2">Xceed</a>

      <nav aria-label="Role switcher" class="me-auto">
        <ul class="navbar-nav flex-row gap-3">
          <IfCoach>
            <:isCoach>
              <li class="nav-item">
                <LinkTo
                  class="nav-link fw-bold"
                  @route="coaching.coach"
                >Coach</LinkTo>
              </li>
            </:isCoach>
          </IfCoach>
          <IfCoachee>
            <:isCoachee>
              <li class="nav-item">
                <LinkTo
                  class="nav-link fw-bold"
                  @route="coaching.coachee"
                >Coachee</LinkTo>
              </li>
            </:isCoachee>
          </IfCoachee>
        </ul>
      </nav>

      <div
        class="d-flex align-items-center gap-3 gap-lg-4 ms-auto flex-shrink-0"
      >
        <ThemeToggle />
        <button
          type="button"
          class="btn btn-link link-primary p-1 d-xl-none d-inline-flex align-items-center gap-1 border-0 text-decoration-none fw-semibold"
          aria-label="Open menu"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebarMobileMenu"
        >
          <iconify-icon inline icon="ph:list" class="fs-4" aria-hidden="true" />
          Menu
        </button>
      </div>
    </div>
  </div>
</template>;

export default Header;
